import { BrokerNerdsBarkerCoreEnumsAdjustmentType, BrokerNerdsBarkerCoreModelsPricingTrailingFloor } from '../api';

const normalizeTrailingFloorDisplayValue = (displayValue: number) => (displayValue > 0 ? -displayValue : displayValue);

export const getTrailingFloorDisplayValue = (trailingFloor?: BrokerNerdsBarkerCoreModelsPricingTrailingFloor) => {
  if (!trailingFloor) {
    return 0;
  }

  if (trailingFloor.typeId === BrokerNerdsBarkerCoreEnumsAdjustmentType.Percentage) {
    return parseFloat(((trailingFloor.value - 1) * 100).toFixed(4));
  }

  return trailingFloor.value > 0 ? -trailingFloor.value : trailingFloor.value;
};

export const getTrailingFloorRuleValue = (displayValue: number, typeId: BrokerNerdsBarkerCoreEnumsAdjustmentType) => {
  const normalizedDisplayValue = normalizeTrailingFloorDisplayValue(displayValue);

  if (typeId === BrokerNerdsBarkerCoreEnumsAdjustmentType.Percentage) {
    return parseFloat((1 + normalizedDisplayValue / 100).toFixed(4));
  }

  return normalizedDisplayValue;
};

export const normalizeTrailingFloor = (trailingFloor?: BrokerNerdsBarkerCoreModelsPricingTrailingFloor) => {
  if (!trailingFloor) {
    return trailingFloor;
  }

  if (trailingFloor.typeId === BrokerNerdsBarkerCoreEnumsAdjustmentType.Amount && trailingFloor.value > 0) {
    return {
      ...trailingFloor,
      value: -trailingFloor.value,
    };
  }

  return trailingFloor;
};

export const isValidTrailingFloor = (trailingFloor?: BrokerNerdsBarkerCoreModelsPricingTrailingFloor) => {
  if (!trailingFloor) {
    return false;
  }

  if (trailingFloor.typeId === BrokerNerdsBarkerCoreEnumsAdjustmentType.Amount) {
    return trailingFloor.value <= 0;
  }

  return trailingFloor.value > 0 && trailingFloor.value <= 1;
};
